import EmConstrucao from "./EmConstrucao";


function Contatenos() {
  return (
    <EmConstrucao />
  );
}

export default Contatenos;
